import React from 'react';

import BackButton from '@/components/BackButton/BackButton';
import {ScrollArea} from '@/components/ScrollArea/ScrollArea';
import ROUTE_PATHS from '@/consts/route/routePaths';
import HomePageTopNavigation from '@/containers/HomePageTopNavigation/HomePageTopNavigation';
import HomePageLayout from '@/views/Home/HomePageLayout';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

const AutoDeliveryPageDesktopLayout = ({children}) => {
    return (
        <HomePageLayout className='bg-primary-dark-5' activePath={ROUTE_PATHS.HOME_PAGE}>
            <WarningBannersTop
                source={WARNING_BANNER_SOURCE_TYPES.AUTO_DELIVERY}
                className='ml:pl-[var(--sidebar-width)]'
            />
            <HomePageTopNavigation profileControlsClassName='bg-primary-dark-5' />
            <div className='flex h-[calc(100vh-var(--hw-h))] min-h-full px-16 pt-24'>
                <div className='flex w-full flex-1 gap-4'>{children}</div>
            </div>
        </HomePageLayout>
    );
};

AutoDeliveryPageDesktopLayout.Start = ({children, onBack}) => {
    return (
        <ScrollArea className='w-full pb-8 pr-4' viewportClassName='snap-y snap-proximity'>
            <BackButton onClick={onBack} className='mb-4 snap-start' />
            {children}
        </ScrollArea>
    );
};
AutoDeliveryPageDesktopLayout.End = ({children}) => {
    return (
        <ScrollArea
            className='flex w-[45%] shrink-0 flex-col overflow-auto rounded-t-[30px] bg-romance'
            viewportClassName='[&>div]:h-full'
        >
            <div className='flex h-full flex-col'>
                <div className='w-full flex-1 p-8'>{children}</div>
                <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.AUTO_DELIVERY} />
            </div>
        </ScrollArea>
    );
};

export default AutoDeliveryPageDesktopLayout;
